import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import TextContent from './text-content';
import Button from './button';

const NavBookingsOverlay = ({ isActive }) => {
	const bookings = useStaticQuery(graphql`
		{
			bookings: allDatoCmsBookingsOverlay(sort: { position: ASC }) {
				nodes {
					id
					title
					position
					tag
					background
					buttonLink
					buttonText
					copy {
						blocks
						links
						value
					}
				}
			}
		}
	`);
	const data = bookings.bookings.nodes;
	return (
		<div
			className={`overlay nav-bookings-overlay ${
				isActive ? 'is-active' : ''
			}`}
			data-lenis-prevent
		>
			<div className='nav-bookings-inner'>
				{data.map((item, index) => (
					<div
						className={`cta-boxes-item background-${item.background} rounded-edges backdrop nav-bookings-item `}
						style={{ '--index': index }}
						key={item.id}
					>
						{item.tag !== '' && (
							<span
								className={`tag rounded-edges background-${item.background}`}
							>
								{item.tag}
							</span>
						)}
						<h3>{item.title}</h3>
						<TextContent data={item.copy} />
						<Button size='large' url={item.buttonLink} emoji=''>
							{item.buttonText}
						</Button>
					</div>
				))}
			</div>
		</div>
	);
};

export default NavBookingsOverlay;
